import React, { Component } from 'react'
import Select from 'views/pages/Select'
import Overlay, { Header, Content } from 'views/pages/Overlay'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import './styles/styles.css'
import { toggleNewLanguageOverlay } from 'store/ConfigurationSettings/LanguageConfig/actions'
import { useDispatch, useSelector } from 'react-redux'
import DefaultModal from 'views/pages/Modal'
import { onChangeNewLanguageName } from 'store/ConfigurationSettings/LanguageConfig/actions'
import { addNewLanguage } from 'store/ConfigurationSettings/LanguageConfig/actions'
import { Input } from 'reactstrap'
import SubmitModalButton from 'components/Custom/SubmitModalButton'

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const dispatch = useDispatch()
  const language = props.languageData
  console.log('props', props)

  return (
    props.defaultModal && (
      <DefaultModal
        isOpen={props.defaultModal}
        title={language.language?.data.settings.add_new_language}
        selectedTab={'addNewLanguage'}
        size={'sm'}
      >
        <Content cn='commboard-content'>
          <div className='add-lang-form'>
            <Input
              type='text'
              placeholder={language.language?.data.settings.language_name}
              className='mb-3'
              name='language_name'
              value={props.newLanguageName}
              onChange={(e) =>
                dispatch(onChangeNewLanguageName(e.target.value))
              }
            />
            <div style={{ marginTop: '90px' }}>
              <SubmitModalButton
                text={language.language?.data.settings.add_language}
                customFn={() => dispatch(addNewLanguage())}
              />
            </div>
          </div>
        </Content>
      </DefaultModal>
    )
  )
}
